exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._18_lExCqEkFzCK0TLVrO4h{max-width:1260px;margin:40px auto 120px auto;padding:0 30px}._18_lExCqEkFzCK0TLVrO4h h1{margin-bottom:20px}._18_lExCqEkFzCK0TLVrO4h._1_nrWFktxk0p86W6b0XCw3{max-width:760px;padding:0 30px}._3Zaum1l1bTBbf3-WrmI07r{line-height:40px;color:#fff;text-align:center;font-weight:500;background:linear-gradient(to right, #f12711, #f5af19)}.dMFo10SaZ3CmfBHcaCb11{display:grid;grid-column-gap:30px;grid-row-gap:30px}@media screen and (max-width: 800px){.dMFo10SaZ3CmfBHcaCb11{display:block}}._2IQwg3NWk3ARTTWPU2oAxi{color:#757575;margin:100px 0 60px 0;text-align:center}\n", ""]);

// Exports
exports.locals = {
	"AdminLayout": "_18_lExCqEkFzCK0TLVrO4h",
	"narrow": "_1_nrWFktxk0p86W6b0XCw3",
	"prodWarn": "_3Zaum1l1bTBbf3-WrmI07r",
	"Grid": "dMFo10SaZ3CmfBHcaCb11",
	"suggestionBox": "_2IQwg3NWk3ARTTWPU2oAxi"
};